import Gravity from 'Gravity';

const portfolioManagerForm = () => {
    if (!document.querySelector('.gg-portfolio-manager-form')) {
        return;
    }

    /* eslint-disable */
    jQuery(document).ready(() => {
        jQuery(document).on('gform_confirmation_loaded', (_e, formID) => {
            document
                .querySelector(`#gform_confirmation_wrapper_${formID}`)
                .closest('.gg-portfolio-manager-form')
                .classList.add('gg-portfolio-manager-form__successful');
        });
    });
    /* eslint-enable */
};
Gravity.ready(portfolioManagerForm);
